import api from './api'
import {
  HippaConsentData,
  HippaConsentResponse,
  PatientConsentData,
  PatientConsentResponse,
  FamilyConsentData,
  FamilyConsentResponse,
} from '@/types'

/**
 * Service for handling consent operations (HIPAA for providers, Intake for patients)
 */
export class ConsentService {
  /**
   * Submit HIPAA consent signature (for therapists/providers)
   */
  static async submitHippaConsent(
    consentData: HippaConsentData
  ): Promise<HippaConsentResponse> {
    const response = await api.post<HippaConsentResponse>(
      '/agreements/signed/therapist',
      consentData
    )
    return response.data
  }

  /**
   * Get HIPAA consent status (optional, for checking status)
   */
  static async getHippaConsentStatus(): Promise<{ hasHippaSigned: boolean }> {
    const response = await api.get<{ hasHippaSigned: boolean }>(
      '/therapist/hippa-consent/status'
    )
    return response.data
  }

  /**
   * Submit Patient Intake & Consent Packet signature
   */
  static async submitPatientConsent(
    consentData: PatientConsentData
  ): Promise<PatientConsentResponse> {
    const response = await api.post<PatientConsentResponse>(
      '/agreements/signed/patient',
      consentData
    )
    return response.data
  }

  /**
   * Submit Family Member / Caregiver Access Consent signature
   */
  static async submitFamilyConsent(
    consentData: FamilyConsentData
  ): Promise<FamilyConsentResponse> {
    const response = await api.post<FamilyConsentResponse>(
      '/agreements/signed/family',
      consentData
    )
    return response.data
  }
}
